"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooleanCell = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const Check_1 = __importDefault(require("@material-ui/icons/Check"));
const Remove_1 = __importDefault(require("@material-ui/icons/Remove"));
const table_styles_1 = require("../table-styles");
function BooleanCell({ value }) {
    const classes = table_styles_1.useStyles();
    return (react_1.default.createElement(Typography_1.default, { classes: { root: clsx_1.default(classes.tableCell, classes.tableCellFlex) } }, value ? react_1.default.createElement(Check_1.default, null) : react_1.default.createElement(Remove_1.default, null)));
}
exports.BooleanCell = BooleanCell;
BooleanCell.displayName = 'BooleanCell';
//# sourceMappingURL=boolean-cell.js.map